import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { webSocket } from 'rxjs/webSocket';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs';

const WS_URL = environment.ws_url;

enum PostProcessStatus {
    MerginCloseVertices = "merge_close_vertices",
    Meshing = "meshing",
    RemovingSmallParts = "removing_small_parts",
    ClosingHoles = "closing_holes",
    Success = "success",
    Failed = "failed"
}

export interface PostProcess {
    scanId: string,
    fileName: string,
    status: PostProcessStatus

}

@Injectable({
    providedIn: 'root'
})
export class WebsocketService {

    public subject = webSocket(WS_URL);

    // Observable para rastrear el estado de la conexión
    private connectionStatus$ = new BehaviorSubject<boolean>(false);

    public connectDefault(): void {
        // Suscripción al WebSocket
        this.subject.subscribe(
            msg => {
                console.log('Conexión establecida con el servidor WebSocket');
                console.log(msg)
                // this.handleMessage(msg); 
                this.connectionStatus$.next(true);
            },
            err => {
                console.log('Error receiving: ', err);
                this.connectionStatus$.next(false); // Desconectado en caso de error
            },
            () => {
                console.log('Connection closed');
                this.connectionStatus$.next(false); // Desconectado al cerrar la conexión
            }
        );
    }

    private handleMessage(msg: any): void {
        let parsed = JSON.parse(JSON.stringify(msg));

        // Actualiza el estado de SweetAlert según el estado recibido
        Swal.update({
            title: parsed.status,
        });
        Swal.showLoading();

        if (parsed.status === PostProcessStatus.Success) {
            Swal.update({
                icon: "success",
                html: "All the steps completed!",
                allowOutsideClick: true,
                showConfirmButton: true,
                allowEscapeKey: true,
            });
            Swal.hideLoading();
        }
    }

    public getConnectionStatus() {
        return this.connectionStatus$.asObservable();
    }

    public connect(scanId: string): void {

        this.subject.subscribe(
            msg => {
                let response = JSON.stringify(msg);
                let parsed = JSON.parse(response);

                Swal.update({
                    title: parsed.status,
                })
                Swal.showLoading()
                if (parsed.status == PostProcessStatus.Success) {
                    Swal.update({
                        icon: "success",
                        html: "All the steps completed!",
                        allowOutsideClick: true,
                        showConfirmButton: true,
                        allowEscapeKey: true,
                    })
                    Swal.hideLoading()
                }

            }, // Called whenever there is a message from the server.
            err => console.log("error receiving" + err), // Called if at any point WebSocket API signals some kind of error.
            () => console.log('complete') // Called when connection is closed (for whatever reason).
        );

        this.createScanIdConnection(scanId)

    }

    createScanIdConnection(scanId: string) {
        this.subject.next({ scanId, action: "scanIdToConnection" })
    }

    disconnect() {
        this.subject.unsubscribe()
        this.connectionStatus$.next(false);
    }
}
